import React, { useState, useEffect, Fragment, useRef } from 'react';
import { useAlert } from 'react-alert';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Grid,
  TextField,
  makeStyles,
  Container,
  Button,
  CardContent,
  Divider,
  InputLabel,
  CardHeader,
  MenuItem,
  Table, 
  Paper, 
  TablePagination
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from 'yup';
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import xlsx from 'json-as-xlsx';
import ReactToPrint from 'react-to-print';
import CreatePDF from './CreatePDF';
import { LoadingComponent } from '../../../../utils/newLoader';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from 'moment';
import TableContainer from '@material-ui/core/TableContainer';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: 'red'
  },
  colorRecord: {
    backgroundColor: 'green'
  }
}));

const screenCode = 'ADVANCEPAYMENTSREMOVALREPORT';

export default function AdvancePaymentRemovalReport(props) {
  const [title, setTitle] = useState('Advance Payments Removal Report');
  const classes = useStyles();
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [fromDate, handleFromDate] = useState(new Date());
  const [toDate, handleToDate] = useState(new Date());
  const [APRemovalDetailList, setAPRemovalDetailList] = useState([]);
  const [APRemovalDetail, setAPRemovalDetail] = useState({
    groupID: 0,
    factoryID: 0,
    registrationNumber: '',
    fromDate: '',
    toDate: '',
  });

  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: '0',
    factoryName: '0',
    fromDate: '',
    toDate: '',
  });
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const [csvHeaders, SetCsvHeaders] = useState([]);
  const navigate = useNavigate();
  const alert = useAlert();
  const componentRef = useRef();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const handlePageChange = (event, newPage) => {
      setPage(newPage);
    };
  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  useEffect(() => {
    trackPromise(getPermission());
    trackPromise(getGroupsForDropdown());
  }, []);

  useEffect(() => {
      getFactoriesForDropdown();
      setAPRemovalDetailList([]);
  }, [APRemovalDetail.groupID]);

  useEffect(() => {
    setAPRemovalDetailList([]);
  }, [APRemovalDetail.factoryID]);

  useEffect(() => {
    setAPRemovalDetailList([]);
  }, [fromDate]);

  useEffect(() => {
    setAPRemovalDetailList([]);
  }, [toDate]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      p => p.permissionCode == 'VIEWADVANCEPAYMENTSREMOVALREPORT'
    );

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(
      p => p.permissionCode == 'GROUPDROPDOWN'
    );
    var isFactoryFilterEnabled = permissions.find(
      p => p.permissionCode == 'FACTORYDROPDOWN'
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
    });

    setAPRemovalDetail({
      ...APRemovalDetail,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    });
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(APRemovalDetail.groupID);
    setFactoryList(factories);
  }

  async function GetAPRemovalDetails() {
  let model = {
    groupID: parseInt(APRemovalDetail.groupID),
    factoryID: parseInt(APRemovalDetail.factoryID),
    fromDate: fromDate.toISOString().split('T')[0],
    toDate: toDate.toISOString().split('T')[0],     
  };
  getSelectedDropdownValuesForReport(model);
  const response = await services.getAdvancePaymentsRemovalDetailsDateRange(model);
  if (response.statusCode == 'Success' && response.data != null) {
    setAPRemovalDetailList(response.data);
    createDataForExcel(response.data);

    if (response.data.length == 0) {
      alert.error('No records to display');
    }
  } else {
    alert.error(response.message);
  }
}

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  async function createDataForExcel(array) {
    var res = [];

    if (array != null) {
      array.map(x => {
        var vr = {
          'Issuing Date': moment(x.issuingDate).format('YYYY/MM/DD'),
          'Removed Date': moment(x.modifiedDate).format('YYYY/MM/DD'),
          'Route Name': x.routeName,
          'Registration Number': x.registrationNumber,
          'Vocuher Code': x.voucherCode,
          'Removed By': x.userName,
          'Source': x.advanceRequestType === 2
            ? 'Over Advanced'
            : x.advanceRequestType === 3
              ? 'Direct Advanced'
              : x.advanceRequestType,
          'Removed By': x.userName ,
          'Amount': x.approvedAmount ? x.approvedAmount : '0.00',
        };
        res.push(vr);
      });

      res.push({});

      var vr = {
        'Issuing Date': 'Group :' + selectedSearchValues.groupName,
        'Removed Date': 'Factory :' + selectedSearchValues.factoryName,

      };
      res.push(vr);
      var vr = {
        'Issuing Date': 'From Date :' + moment(selectedSearchValues.fromDate).format('YYYY/MM/DD'),
        'Removed Date': 'To Date :' + moment(selectedSearchValues.toDate).format('YYYY/MM/DD'),

      };
      res.push(vr);
    }

    return res;
  }

  async function createFile() {
    var file = await createDataForExcel(APRemovalDetailList);
    var settings = {
      sheetName: 'Advance Payments Removal Report',
      fileName:
        'Advance Payments Removal Report - ' +
        selectedSearchValues.groupName +
        ' - ' +
        selectedSearchValues.factoryName,
      writeOptions: {}
    };

    let keys = Object.keys(file[0]);
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem });
    });

    let dataA = [
      {
        sheet: 'Advance Payments Removal Report',
        columns: tempcsvHeaders,
        content: file
      }
    ];

    xlsx(dataA, settings);
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value;
    setAPRemovalDetail({
      ...APRemovalDetail,
      [e.target.name]: value
    });
    setAPRemovalDetailList([]);
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: GroupList[searchForm.groupID],
      factoryName: FactoryList[searchForm.factoryID],
      fromDate: searchForm.fromDate,
      toDate: searchForm.toDate,
    });
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    );
  }

  const getPageMargins = () => {
    return `@media print {
        @page {
            background-color: white !important;
        }
   
        body {
            background-color: white !important;
        }
    }`;
  };

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: APRemovalDetail.groupID,
              factoryID: APRemovalDetail.factoryID,
              fromDate: APRemovalDetail.fromDate,
              toDate: APRemovalDetail.toDate
            }}
            validationSchema={Yup.object().shape({
              groupID: Yup.number().required('Group is required').min('1', 'Group is required'),
              factoryID: Yup.number().required('Factory is required').min('1', 'Factory is required')
            })}
            onSubmit={() => trackPromise(GetAPRemovalDetails())}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>

                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              size="small"
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={e => handleChange(e)}
                              value={APRemovalDetail.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(
                                touched.factoryID && errors.factoryID
                              )}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              size="small"
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={e => handleChange(e)}
                              value={APRemovalDetail.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="fromDate">From Date *</InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                error={Boolean(touched.fromDate && errors.fromDate)}
                                fullWidth
                                helperText={touched.fromDate && errors.fromDate}
                                variant="outlined"
                                format="yyyy/MM/dd"
                                margin="dense"
                                name='fromDate'
                                id='fromDate'
                                size='small'
                                value={fromDate}
                                onChange={(e) => {
                                  handleFromDate(e)
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change fromDate',
                                }}
                                maxDate={new Date()}
                                autoOk
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="todate">To Date *</InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                error={Boolean(touched.todate && errors.todate)}
                                fullWidth
                                helperText={touched.todate && errors.todate}
                                variant="outlined"
                                format="yyyy/MM/dd"
                                margin="dense"
                                name='todate'
                                id='todate'
                                size='small'
                                value={toDate}
                                onChange={(e) => {
                                  handleToDate(e)
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change todate',
                                }}
                                minDate={fromDate}
                                maxDate={new Date()}
                                autoOk
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>

                        </Grid>
                        <Box display="flex" flexDirection="row-reverse" p={2}>
                          <Button
                            color="primary"
                            type="submit"
                            variant="contained"
                          >
                            Search
                          </Button>
                        </Box>
                      </CardContent>
                      <br />
                      <br />

                      {APRemovalDetailList.length > 0 ?
                        <Box minWidth={1050} style={{padding:'10px'}}>
                          <TableContainer component={Paper}>
                            <Table className={classes.table} aria-label="simple table" size='small'>
                              <TableHead>
                                <TableRow style={{ border: "1px solid #ccc" }}>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid #ccc", fontSize: '16px', width: '1%' }}>Issuing Date</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid #ccc", fontSize: '16px', width: '1%' }}>Removed Date</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid #ccc", fontSize: '16px', width: '3%' }}>Route</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid #ccc", fontSize: '16px', width: '2%' }}>Registration Number</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid #ccc", fontSize: '16px', width: '2%' }}>Voucher Code</TableCell> 
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid #ccc", fontSize: '16px', width: '3%' }}>Source</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid #ccc", fontSize: '16px', width: '3%' }}>Removed By</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid #ccc", fontSize: '16px', width: '2%' }}>Amount(RS)</TableCell>    
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {APRemovalDetailList.slice(page * limit, page * limit + limit).map((row, i) => (
                                  <TableRow style={{ border: "1px solid #ccc" }} key={i}>
                                    <TableCell component="th" scope="row" align="center" style={{ border: "1px solid #ccc", width: '1%' }}> {row.issuingDate != null ? moment(row.issuingDate ).format('YYYY/MM/DD'):null}</TableCell>
                                    <TableCell component="th" scope="row" align="center" style={{ border: "1px solid #ccc", width: '1%' }}> {row.modifiedDate != null ? moment(row.modifiedDate ).format('YYYY/MM/DD'):null}</TableCell>
                                    <TableCell component="th" scope="row" align="left" style={{ border: "1px solid #ccc", width: '3%' }}> {row.routeName}</TableCell>
                                    <TableCell component="th" scope="row" align="left" style={{ border: "1px solid #ccc", width: '3%' }}> {row.registrationNumber}</TableCell>
                                    <TableCell component="th" scope="row" align="left" style={{ border: "1px solid #ccc", width: '3%' }}> {row.voucherCode}</TableCell>
                                    <TableCell component="th" scope="row" align="left" style={{ border: "1px solid #ccc", width: '3%' }}> {row.advanceRequestType === 2 ? "Over Advanced" : row.advanceRequestType === 3 ? "Direct Advanced" : row.advanceRequestType}</TableCell>    
                                    <TableCell component="th" scope="row" align="left" style={{ border: "1px solid #ccc", width: '3%' }}> {row.userName}</TableCell>
                                    <TableCell component="th" scope="row" align="right" style={{ border: "1px solid #ccc", width: '3%' }}> {row.approvedAmount ? row.approvedAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}</TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                            <TablePagination
                              component="div"
                              count={APRemovalDetailList.length}
                              onChangePage={handlePageChange}
                              onChangeRowsPerPage={handleLimitChange}
                              page={page}
                              rowsPerPage={limit}
                              rowsPerPageOptions={[5, 10, 25]}
                            />
                          </TableContainer>
                        </Box> : null}

                        
                      {APRemovalDetailList.length > 0 ? (
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={createFile}
                          >
                            EXCEL
                          </Button>
                          <ReactToPrint
                            documentTitle={
                              'Advance Payments Removal Report'
                            }
                            trigger={() => (
                              <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorCancel}
                              >
                                PDF
                              </Button>
                            )}
                            pageStyle={getPageMargins()}
                            content={() => componentRef.current}
                          />
                          <div hidden={true}>
                            <CreatePDF
                              ref={componentRef}
                              APRemovalDetailListData={APRemovalDetailList}
                              selectedSearchValues={selectedSearchValues}
                            />
                          </div>
                        </Box>
                      ) : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
